"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSwitch = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SwitchMixin = require("../../mixins/components/SwitchMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledSwitch = /*#__PURE__*/(0, _styledComponents.default)('label').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['disabled', 'size'])
}).withConfig({
  displayName: "StyledSwitch",
  componentId: "c11n-8-107-0__sc-igsiw0-0"
})(["", ""], _SwitchMixin.SwitchMixin);
exports.StyledSwitch = StyledSwitch;